<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
      <div class="fw-bold w-auto my-0 lh-base h5" >成果列表 / 全部</div>
      <button @click="openAnnounceAchi"  class="btn btn-sm btn-primary me-1 flex-shrink-0" type="button"><i class="bi bi-send-fill me-1"></i>发布成果</button>
    </div>
    <div class="row g-2  border-bottom py-2 px-1">
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele1">所在区域：</label>
        <select v-model="params.region_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele1" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of region" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele2">知识产权：</label>
        <select v-model="params.ip_right_id" @change="getList(true)"  class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele2" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of ip_right" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele3">转让方式：</label>
        <select v-model="params.transfer_way_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele3" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of transfer_way" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele4">成熟度：</label>
        <select v-model="params.maturity_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele4" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of maturity" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele5">成果水平：</label>
        <select v-model="params.result_level_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele5" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of result_level" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-4 d-flex align-items-baseline">
        <input class="form-control form-control-sm  ms-1 mt-1 " v-model="params.keyword"  placeholder="请输入关键词">
        <a class="btn btn-sm btn-outline-primary flex-shrink-0 small ms-2"  @click="getList(true)">搜索</a>
      </div>
    </div>
    <!--没有数据-->
    <NodataCom :show="showNodata"></NodataCom>
    <!--  正在加载-->
    <LoadingCom :show="showLoading"></LoadingCom>
    <!--    列表-->
    <div class="p-2 list-box border-bottom" v-for="(item,index) of list" :key="index">
      <div class=" p-2">
        <div class="d-flex align-content-center justify-content-between  rounded-2 mb-2 ">
          <div class=" w-auto my-0 lh-base " >
            <div class="fw-bold title-left me-3 point-curser" @click="goto(item)" >{{item.Name}}</div>
          </div>
          <span class="badge title-badge badge-little-lightblue rounded-pill px-2 flex-shrink-0" v-if="item.Maturity && item.Maturity.Name">{{item.Maturity?item.Maturity.Name:0}}</span>
<!--          <span class="badge title-badge badge-little-lightblue rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===2">通过小试</span>-->
<!--          <span class="badge title-badge badge-little-lightblue rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===3">正在研发</span>-->
<!--          <span class="badge title-badge badge-little-lightblue rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===4">通过中试</span>-->
<!--          <span class="badge title-badge badge-little-lightblue rounded-pill px-2 flex-shrink-0" v-else>可以量产</span>-->
<!--          <span class="badge title-badge text-bg-primary rounded-pill px-2 flex-shrink-0" v-if="item.statue===0">审核中</span>-->
<!--          <span class="badge title-badge badge-little-green rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===1">已有小样</span>-->
<!--          <span class="badge title-badge text-bg-warning text-white rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===2">已撤回</span>-->
<!--          <span class="badge title-badge text-bg-danger rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===3">已未通过</span>-->
        </div>
        <div class="d-flex align-items-center flex-wrap ">
          <div class="py-1 me-2">
            <small class="small me-3 text-body-secondary mb-1">发布时间：{{item.CreatedAtdeal}}</small>
          </div>
          <div class="py-1">
            <small class="small me-3 text-body-secondary mb-1">发布单位：{{item.Company }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PaginationCom
      @pageChange="pageChangeFun($event)"
      :totalIn="total"
      :currentIn="params.current"
      :pageSizeIn="params.pageSize"
  ></PaginationCom>
  <!--   发布成果-->
<!--  <AnnounceAchievementsModel  v-model:show="showAnnounceAchievementsModel" ></AnnounceAchievementsModel>-->

</template>

<script setup>
// import AnnounceAchievementsModel from "@/components/AnnounceAchievementsModel"
import NodataCom from "@/layout/NodataCom"
import LoadingCom from "@/layout/LoadingCom"
import {computed, defineProps, onMounted, reactive, ref, watch} from "vue";
import {getResults} from "@/api/Result";
import router from "@/router";
import store from "@/store";
import {showToast} from "@/utils/toast";
import {formatTime} from "@/utils/dateFun";
import {loginModelOpen} from "@/utils/authCheck";
// 获取筛选项
const region = computed(()=>store.state.dictModel.region) //所在区域
const ip_right = computed(()=>store.state.dictModel.ip_right) //知识产权
const transfer_way = computed(()=>store.state.dictModel.transfer_way) //转让方式
const result_level = computed(()=>store.state.dictModel.result_level) //成果水平
const maturity = computed(()=>store.state.dictModel.maturity) //成熟度
const login = computed(()=>store.state.loginModel.login) //是否登录
const params = reactive({
  keyword:"",//搜索关键词
  domain_id:"",//领域 ID,从父组件传入
  region_id:"",//区域 ID
  ip_right_id:"",//知识产权 ID
  transfer_way_id:"",//转让方式 ID
  maturity_id:"",//成熟度  ID
  result_level_id:"",//成果水平  ID
  current:1,
  pageSize:10,
})
const total  = ref(0)
// // 发布成果
// const showAnnounceAchievementsModel = ref(false)
// 发布成果
const openAnnounceAchi = ()=>{
  // showAnnounceAchievementsModel.value = true
  if(!login.value){
   return loginModelOpen(true)
  }
  router.push({path:"/supplyadd"})
}

const list = ref({})
const showNodata = ref(false)
const showLoading = ref(false)
const props = defineProps({
  lyKey: {
    default: "", // 领域id
  }
})
watch(()=>props.lyKey,(n,o)=>{
  if(n){
    getList && getList(true)
  }else{
    getList && getList(true)
  }
})

onMounted(()=>{
  getList()
})

const pageChangeFun = (e)=>{
  params.current = e.page
  params.pageSize = e.pageSize
  getList()
}
// 获取消息列表
const getList = async (currentinit)=>{
  if(currentinit){
    params.current = 1
  }
  showLoading.value = true
  showNodata.value = false
  list.value = []
  total.value = 0
  params.domain_id = props.lyKey
  const res =await  getResults(params)
  showLoading.value = false
  if(res.err_code==0){
    const data =  res.data || []
    data.forEach(item=>{
      if(item.CreatedAt){
        item.CreatedAtdeal = formatTime(item.CreatedAt)
      }
      // ch.InstitutionName = ch.Institution.Name
      // // 预约方式
      // if(ch.Mode==1){
      //   ch.modeName = "自主上机"
      // }else if(ch.Mode==2){
      //   ch.modeName = "送样检测"
      // }else{
      //   ch.modeName = "自主上机/送样检测"
      // }
    })
    list.value = data
    total.value = res.total || 0
    if(data.length<=0){
      showNodata.value = true
    }
  }else{
    showToast("danger",res.err_msg || "请求出错")
  }
}
// 跳转
const goto = (item) => {
  router.push({path:'/supplyDetail',query:{id:item.ID}})
}
</script>

<style scoped lang="scss">

.title-left{
  word-break: break-all;
}
.title-badge{
  height: 1.5rem;
  line-height: 1rem;
  font-size: 0.7rem;
  font-weight: normal;
  width: 6rem;
  text-align: center;
}
.small{
  font-size: 0.9rem;
}
.list-box{
  box-sizing: border-box;
}

.small-btn-size{
  height: 1.5rem;
  line-height: 1rem;
}

.btn-check + .btn{
  border: none;
}
.btn-check:checked + .btn{
  color: #0d6efd;
}
//sm: 540px,
//md: 720px,
//lg: 960px,
// xl: 1140px,
// xxl: 1320px
.tabs-box{
  box-sizing: border-box;
  justify-content: space-between !important;
  @media (min-width: 1400px){
    justify-content: start !important;
  }
}
.form-item-box{
  width: 48.5% !important;
  box-sizing: border-box;
  @media (min-width: 576px){
    width: 48.5% !important;
  }
  @media (min-width: 768px){
    width: 32.33% !important;
  }
  @media (min-width: 992px){
    width: 32.33% !important;
  }
  @media (min-width: 1200px){
    width: 32.33% !important;
  }
  @media (min-width: 1400px){
    width: 16% !important;
    min-width: 120px;
    max-width: 200px;
  }
}

</style>
